export default __webpack_public_path__ + "static/media/myDrive.08383baf.svg";